import { render, staticRenderFns } from "./select_service.vue?vue&type=template&id=799ab828&scoped=true&"
import script from "./select_service.vue?vue&type=script&lang=js&"
export * from "./select_service.vue?vue&type=script&lang=js&"
import style0 from "./select_service.vue?vue&type=style&index=0&id=799ab828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799ab828",
  null
  
)

export default component.exports